import api from '../../../api'
export default{

    cfget(params){
      return api.get(`/inventory/`+params.url,{params})
    },
    cfpost(params){
      return api.post(`/inventory/`+params.url,params)
    },
    cfput(params){
      return api.put(`/inventory/`+params.url,params)
    },
    cfdelete(params){
      return api.delete(`/inventory/`+params.url,params)
    },

}
